export enum PossibleExperienceType {
  PRODUCT_EXPERIENCE = 'Product Experience',
  DIGITAL_HUB = 'Digital Hub',
  SMS_OPT_IN = 'SMS',
}
